import {
    OptionsWithExtraProps,
    SnackbarKey,
    SnackbarMessage,
    useSnackbar,
} from 'notistack';
import { useCallback } from 'react';

const useExtendedSnackbar = () => {
    const snackbar = useSnackbar();

    const enqueueErrorSnackbar = useCallback(
        (
            message: SnackbarMessage,
            options: OptionsWithExtraProps<'error'> = {},
        ): SnackbarKey => {
            // eslint-disable-next-line no-param-reassign
            options.variant = 'error';

            return snackbar.enqueueSnackbar(message, options);
        },
        [snackbar],
    );

    const enqueueSuccessSnackbar = useCallback(
        (
            message: SnackbarMessage,
            options: OptionsWithExtraProps<'success'> = {},
        ): SnackbarKey => {
            // eslint-disable-next-line no-param-reassign
            options.variant = 'success';

            return snackbar.enqueueSnackbar(message, options);
        },
        [snackbar],
    );

    return { ...snackbar, enqueueErrorSnackbar, enqueueSuccessSnackbar };
};

export default useExtendedSnackbar;
